import { CallDirection } from '../../types';
import { LastCallInfo } from './types';

const STORAGE_KEY = 'nice_sap_acw_pending';

interface StoredAcwPendingContext {
  contactId: string;
  skillId: string;
  skillName?: string;
  requireDisposition?: boolean;
  callTraceId?: string;
  direction?: CallDirection | null;
  callerName?: string | null;
  callerNumber?: string | null;
  dnis?: string | null;
  startTime?: string | null;
  endedAt?: string | null;
}

function readStorage(): StoredAcwPendingContext | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as StoredAcwPendingContext;
    if (!parsed.contactId || !parsed.skillId) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function loadAcwPendingContext(): LastCallInfo | null {
  const stored = readStorage();
  if (!stored) {
    return null;
  }

  return {
    contactId: stored.contactId,
    skillId: stored.skillId,
    skillName: stored.skillName,
    requireDisposition: stored.requireDisposition,
    callTraceId: stored.callTraceId,
    direction: stored.direction ?? null,
    callerName: stored.callerName ?? null,
    callerNumber: stored.callerNumber ?? null,
    dnis: stored.dnis ?? null,
    startTime: stored.startTime ? new Date(stored.startTime) : null,
    endedAt: stored.endedAt ? new Date(stored.endedAt) : null,
  };
}

export function saveAcwPendingContext(info: LastCallInfo): void {
  if (!info.contactId || !info.skillId) {
    return;
  }

  const stored: StoredAcwPendingContext = {
    contactId: info.contactId,
    skillId: info.skillId,
    skillName: info.skillName,
    requireDisposition: info.requireDisposition,
    callTraceId: info.callTraceId,
    direction: info.direction ?? null,
    callerName: info.callerName ?? null,
    callerNumber: info.callerNumber ?? null,
    dnis: info.dnis ?? null,
    startTime: info.startTime?.toISOString() ?? null,
    endedAt: info.endedAt?.toISOString() ?? null,
  };

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  } catch {
    // Ignore quota / private-mode storage errors.
  }
}

export function clearAcwPendingContext(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Ignore storage errors.
  }
}
